var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreat = function SvgGreat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c8bb0",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 14.6a.3.3 0 0 1 0 .13.4.4 0 0 1-.08.11l-.11.08H7.87l-.11-.08a.4.4 0 0 1-.08-.24v-1.9a.3.3 0 0 1 0-.13.4.4 0 0 1 .07-.1.4.4 0 0 1 .1-.08h2.13a.31.31 0 0 1 .24.1.4.4 0 0 1 .08.1.5.5 0 0 1 0 .13Zm-.12-3.93a.17.17 0 0 1 0 .12.4.4 0 0 1-.07.11.4.4 0 0 1-.23.08H8.1a.31.31 0 0 1-.34-.31L7.61 3.9a.36.36 0 0 1 .09-.24.23.23 0 0 1 .11-.08.3.3 0 0 1 .13 0h2.11a.32.32 0 0 1 .25.1.36.36 0 0 1 .09.24Z",
    className: "icon-component-shadow",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.32 14.1a.3.3 0 0 1 0 .13.4.4 0 0 1-.08.11l-.11.08H7.87l-.11-.08a.4.4 0 0 1-.08-.24v-1.9a.3.3 0 0 1 0-.13.4.4 0 0 1 .07-.1.4.4 0 0 1 .1-.08h2.13a.31.31 0 0 1 .24.1.4.4 0 0 1 .08.1.5.5 0 0 1 0 .13Zm-.12-3.93a.17.17 0 0 1 0 .12.4.4 0 0 1-.07.11.4.4 0 0 1-.23.08H8.1a.31.31 0 0 1-.34-.31L7.61 3.4a.36.36 0 0 1 .09-.24.23.23 0 0 1 .11-.08.3.3 0 0 1 .13 0h2.11a.32.32 0 0 1 .25.1.36.36 0 0 1 .09.24Z",
    className: "icon-component"
  })));
};
export default SvgGreat;